import type { FC } from 'react';
import { StringsWrapper } from './Strings.styled';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';

interface StringsProps { }

const Strings: FC<StringsProps> = () => (
   <StringsWrapper>
      <header className="entry-header">
         <h1 className="entry-title" itemProp="headline">Strings</h1>
      </header>
      <div className="entry-content clear" itemProp="text" style={{ height: 'auto !important' }}>
         <p className="text-align-justify">In Java, String may relate to two different things :</p>
         <ol className="text-align-justify">
            <li><strong>Object</strong>&nbsp;
               <ul>
                  <li>Special treatment is given to String in Java as it is treated as an Object.</li>
                  <li>Objects that are backed internally by a char array.</li>
                  <li>There are two ways to create a string object :</li>
                  <li><strong>By string literal </strong>
                     <ul>
                        <li>If means special treatment is asked. JVM will search for an object that contains a hello string; if found, it will use its reference, i.e., its address will be assigned to g; if not found, a new object with a hello string will be created.</li>
                        <li>Example : 
                           <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
                              {
                                 'String g = "hello";'
                              }
                           </SyntaxHighlighter>
                        </li>
                     </ul>
                  </li>
                  <li><strong>By new keyword </strong>
                     <ul>
                        <li>If means no special treatment is asked. So JVM doesn’t apply a search, but definitely, a new object will be created with a hello string in it.</li>
                        <li>Example : 
                           <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
                              {
                                 'String g = new String("hello");'
                              }
                           </SyntaxHighlighter>
                        </li>
                     </ul>
                  </li>
               </ul>
            </li>
            <li><strong>String class </strong>
               <ul>
                  <li>A string is a class, and it contains several built-in methods and properties.</li>
                  <li>It is used to create and manipulate strings or, let’s say, string objects.</li>
                  <li>All string literals in Java are implemented as instances of this class.</li>
                  <li>The class includes methods like compare(), concat(), equals(), split(), length(), replace(), compareTo(), intern(), substring() etc.</li>
                  <li>Example : 
                     <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
                        {
                           'String g = new String("hello");'
                        }
                     </SyntaxHighlighter>
                  </li>
               </ul>
            </li>
         </ol>
      </div>
   </StringsWrapper>
);

export default Strings;
